<script setup>
const props = defineProps({
    color: {
        type: String,
        default: "black",
    },
});
</script>

<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.5 12H20.5"
            :stroke="color"
            stroke-width="2.5"
            stroke-linecap="round"
        />
        <path
            d="M10 6L4.88388 11.1161C4.39573 11.6043 4.39573 12.3957 4.88388 12.8839L10 18"
            :stroke="color"
            stroke-width="2.5"
            stroke-linecap="round"
        />
    </svg>
</template>
